import type { PlayerRef } from '@remotion/player';
import { toast } from '@crabs-ai/ds-react';
import type { TimelineWriteOnlyContext } from '../context-provider';
import { makeItem } from '../items/make-item';
import type { TrackType } from '../state/types';
import type { EditorStarterAsset } from './assets';
import { getErrorStack } from '../utils/asset-upload-utils';
import { captureInsertionTarget } from '@waka/compat/incoming-media';
import { commitIncomingMedia } from '@waka/compat/commit-incoming-media';

export type DropPosition = { x: number; y: number };
export const addAsset = async ({
  file,
  filename,
  timelineWriteContext,
  playerRef,
  dropPosition,
  fps,
  compositionWidth,
  compositionHeight,
  tracks,
  remoteUrl,
  sourceRef,
  timelineStartFrame,
  targetTrackIndex,
  createTrack = false,
}: {
  file: Blob;
  filename: string;
  timelineWriteContext: TimelineWriteOnlyContext;
  playerRef: React.RefObject<PlayerRef | null>;
  dropPosition: DropPosition | null;
  fps: number;
  compositionWidth: number;
  compositionHeight: number;
  tracks: TrackType[];
  remoteUrl?: string;
  sourceRef?: EditorStarterAsset['sourceRef'];
  timelineStartFrame?: number;
  targetTrackIndex?: number | null;
  createTrack?: boolean;
}): Promise<void> => {
  const target = captureInsertionTarget(tracks, targetTrackIndex, createTrack);
  const from = timelineStartFrame ?? playerRef.current?.getCurrentFrame() ?? 0;
  try {
    const { item, asset } = await makeItem({
      file,
      fps,
      compositionWidth,
      compositionHeight,
      playerRef,
      dropPosition,
      remoteUrl: remoteUrl ?? null,
      remoteFileKey: null,
      filename,
    });
    if (sourceRef) asset.sourceRef = sourceRef;
    commitIncomingMedia(
      timelineWriteContext,
      { ...item, from },
      asset,
      target,
      fps,
    );
  } catch (error: unknown) {
    toast({
      type: 'error',
      description: '에셋을 추가하지 못했습니다: ' + getErrorStack(error),
    });
  }
};
